// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7a5bcad3","453":"967d77cc","865":"3d181656"}[chunkId] + ".chunk.js";
};